import { call, put } from "redux-saga/effects";
import { ACTIONS, APIS, KEYS, STORAGE } from "../../_config";
import { CallApi } from "../api/callApi";
import { sagaFunction } from "../api/functions";

export function* searchBrand(action: any): any {
    const yieldPuts = [{ type: ACTIONS.BRANDS.SEARCH_BRAND, payload: "items" }];
    yield call(sagaFunction, action, CallApi.GET, APIS.BRANDS.SEARCH_BRAND, action.payload, true, yieldPuts);
}

export function* addUpdateBrand(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.BRANDS.ADD_UPDATE_BRAND, action.payload, true);
}

export function* deleteBrand(action: any): any {
    yield call(sagaFunction, action, CallApi.POST, APIS.BRANDS.DELETE_BRAND, action.payload, true);
}

export function* getBrandDetails(action: any): any {
    yield call(sagaFunction, action, CallApi.GET, APIS.BRANDS.BRAND_DETAILS, action.payload, true);
}
